<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-titlepage title-page" epub:type="titlepage" id="title-page">
<div class="title-page-title-subtitle-block">
<h1 class="title-page-title case-upper">Queen of Belize</h1>
<h2 class="title-page-subtitle case-upper">Book 4 of the Queens of the Castle Series</h2>
</div>
<div class="title-page-contributor-block">
<div class="title-page-contributor-primary-block">
<h2 class="title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"><span class="title-page-contributor-name case-upper">Aiken Ponder</span></h2>
</div>
</div>
<div class="publisher-block">
<h2 class="title-page-publisher case-upper"><a class="content-external-link" href="http://www.wordstoponderpublishing.com" target="_blank">Words to Ponder Publishing</a></h2>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title-page.vue?6f0e8f98